// @flow

import { I18n } from 'react-redux-i18n';

import officeApi from '../../network/api/officeApi';
import { store } from '../../network/reduce';
import {
  FILTERED_OFFICE_REQUEST,
  FILTER_OFFICES_LIST,
  OFFICE_APPLIED_FILTERS,
  SAVE_OFFICES_CITIES_LIST,
  SAVE_OFFICES_LIST,
  SAVE_OFFICES_MEDIA,
  SET_OFFICES_SELECTED,
} from './officesReducer';
import type { OfficePartial } from '../../types/OfficesType';
import type { Filter } from '../../types/shoppingCenterType';
import { fuzzysearch } from '../../utils/fuzzysearch';
import type { MediaGallery } from '../../types/keepeekType';
import { IS_MEDIA_LOADING } from '../page/pageReducer';

export const fetchOffices = (): Function =>
  (dispatch: () => void) => officeApi.list()
    .then(response => response.json())
    .then((response) => {
      dispatch(saveBaseOfficesList(response));
      dispatch(filterOfficesList(response));
      dispatch(saveOfficeCitiesList(getCities(response)));
    })
    .catch(console.error);

export const fetchOfficesMedias = (officeId: string): Function =>
  (dispatch: () => void) =>
    officeApi.fetchMedias(officeId)
      .then(response => response.json())
      .then((response: MediaGallery[]) => {
        dispatch(saveOfficesMedias(response));
        dispatch(store(IS_MEDIA_LOADING, false));
      })
      .catch(console.error);

export const dischargeOfficeMedia = (): Function =>
  (dispatch: () => void) => {
    dispatch(saveOfficesMedias([]));
    dispatch(store(IS_MEDIA_LOADING, true));
  };

const getCities = (officeList: OfficePartial[]): string[] => {
  const citiesSet = new Set();
  for (let i = 0; i < officeList.length; ++i) {
    citiesSet.add(officeList[i].city);
  }
  return [...citiesSet];
};

export const saveBaseOfficesList = (officeList: OfficePartial[]): Function =>
  (dispatch: () => void) => {
    dispatch(store(SAVE_OFFICES_LIST, officeList));
  };

export const filterOfficesList = (officeList: OfficePartial[]): Function =>
  (dispatch: () => void) => {
    dispatch(store(FILTER_OFFICES_LIST, officeList));
  };

export const saveOfficeCitiesList = (citiesList: string[]): Function =>
  (dispatch: () => void) => {
    dispatch(store(SAVE_OFFICES_CITIES_LIST, citiesList));
  };

export const saveOfficesMedias = (medias: MediaGallery[]): Function =>
  (dispatch: () => void) => {
    dispatch(store(SAVE_OFFICES_MEDIA, medias));
  };

export const selectOffice = (isSelected: boolean) => (dispatch: () => void) => {
  dispatch(store(SET_OFFICES_SELECTED, isSelected));
};

export const applyFilters = (filters: Filter[], search: string): Function =>
  (dispatch: () => void, getState: Function) => {
    const filteredOfficeList = filterOffices(
      getState().office.baseOfficeList,
      filters,
      search,
    );
    dispatch(filterOfficesList(filteredOfficeList));
    dispatch(saveOfficeAppliedFilters(filters));
    dispatch(saveFilteredOfficeRequest(search));
  };

export const saveFilteredOfficeRequest = (officeRequest: string): Function =>
  (dispatch: () => void) => {
    dispatch(store(FILTERED_OFFICE_REQUEST, officeRequest));
  };

export const saveOfficeAppliedFilters = (officeAppliedFilters: Filter[]): Function =>
  (dispatch: () => void) => {
    dispatch(store(OFFICE_APPLIED_FILTERS, officeAppliedFilters));
  };

export const filterOffices =
  (officeList: OfficePartial[], filters: Filter[], search: string): OfficePartial[] => {
    let result = true;
    for (let i = 0; i < filters.length; i++) {
      result = result && filters[i].selected.length === 0;
    }
    if (result && search === '') {
      return officeList;
    }
    return officeList.filter((office) => {
      for (let i = 0; i < filters.length; i++) {
        if (filters[i].label === I18n.t('filters.CITIES') && filters[i].selected.length > 0 && !filters[i].selected.includes(office.city)) {
          return false;
        }
      }
      return fuzzysearch(search, office.name);
    });
  };
